export enum BankAccountMonitoringSystemConnectionStatusTypeEnum {
	UNKNOWN = "Unknown",
	NOT_CONNECTED = "NotConnected",
	NOT_REQUIRED = "NotRequired",
	CONNECTED = "Connected"
}
